// Implements a socket and listens for messages from the server. After receiving a message the message is redirected through
// a dedicated channel.

var App = require('app')
var Config = require('config')

var io = require('socket.io-client')
var socket = io(Config.socket.host)

// -- Socket Routes --
// -------------------

// -- Devices --
// socket.on('devices.event.updated', function (data) { App.globalChannel.trigger('devices:event:updated', data) })
socket.on('devices patched', function (data) { App.globalChannel.trigger('devices:event:updated', data) })
// socket.on('devices created', function (data) { App.globalChannel.trigger('devices:event:updated', data) })
// socket.on('devices updated', function (data) { App.globalChannel.trigger('devices:event:updated', data) })

socket.on('devices.event.error', function (data) {
  App.dialog.alert('Device "' + data.device.name + '" went into error mode')
})

module.exports = socket



// WEBPACK FOOTER //
// ./js/socket.js